//Remove duplicates by only keeping the first instance of each key.
export function removeDuplicates<T>(arr: T[], getKey: (item: T) => any): T[] {
    return arr.filter((item, index, self) =>
        index === self.findIndex(other => getKey(other) === getKey(item))
    );
}